import { render, staticRenderFns } from "./PaymentOrderList.vue?vue&type=template&id=2650e1bf&scoped=true&"
import script from "./PaymentOrderList.vue?vue&type=script&lang=js&"
export * from "./PaymentOrderList.vue?vue&type=script&lang=js&"
import style0 from "./PaymentOrderList.vue?vue&type=style&index=0&id=2650e1bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2650e1bf",
  null
  
)

export default component.exports